var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-result',{attrs:{"status":"403","title":"403","sub-title":"对不起，您没有访问本页面的权限。"},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v(" 回到首页 ")])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }